import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import { Provider } from "react-redux";

if (process.env.NODE_ENV === "development") {
  window.addEventListener("unhandledrejection", (event) => {
    const r = event.reason;
    console.warn(
      "[dev] unhandledrejection — inspect `event.reason` in Sources. Common causes: reject() with no value, Firebase token refresh, or a browser extension.",
      r,
    );
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
